<template>
  <div class="userNav noUserSelect">
    <div class="userNav-nav" :class="{'m-visible': changesFound}">
      <div class="userNav-space"></div>
      <button-com
        iconName="check"
        iconSize="small"
        :text="saveStateText"
        class="bm-confirm"
        :class="{'bm-loading': savingChanges}"
        @click.native="saveChanges(2000)"
      ></button-com>
      <div class="userNav-space"></div>
      or
      <div class="userNav-space"></div>
      <button-com
        iconName="settings_backup_restore"
        iconSize="small"
        text="Restore"
        class="bm-cancel"
        @click.native="restore"
      ></button-com>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      savingChanges: false
    }
  },
  computed: {
    feeds () {
      return this.$store.state.feeds
    },
    currentFeed () {
      return this.$store.state.currentFeed
    },
    name () {
      return this.$store.state.userInfo.name
    },
    changesFound () {
      return this.$store.state.changesFound
    },
    saveStateText () {
      return this.savingChanges ? 'Saving...' : 'Save'
    }
  },
  methods: {
    restore () {
      const restore = confirm('Är du säker på att du vill återställa dina ändringar?')

      if (!restore) {
        return
      }

      this.$http.get(
        'http://api.lootbox.se/restoresession',
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(({body}) => {
        if (!body) {
          return
        }

        if (body.feeds.length) {
          this.$store.commit('feeds', body.feeds)
        }

        this.saveChanges(0)
      }, () => {
        console.log('Fail!')
      })
    },
    saveChanges (time) {
      this.savingChanges = true
      this.$http.post(
        'http://api.lootbox.se/saveChanges',
        {
          feeds: JSON.stringify(this.feeds)
        },
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(() => {
        setTimeout(() => {
          this.$store.commit('changesFound', false)
          this.savingChanges = false
        }, time)
      }, () => {
        console.log('Fail!')
      })
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('userNav')
  height: 40px
  position: absolute
  top: 15px
  right: 15px

  +element('space')
    width: 15px

  +element('nav')
    line-height: 40px
    display: flex
    align-items: center
    justify-content: flex-end
    cursor: default
    position: relative
    box-sizing: border-box
    height: 40px
    transition: .4s
    transform: translateX(100%) translateZ(0)

    +modifier('visible')
      transform: translateX(0) translateZ(0)

  +element('username')
    margin-right: 50px
    margin-left: 30px

</style>



// WEBPACK FOOTER //
// src/components/Usernav.vue